/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var StackExchangeIcon = createIcon({
  name: 'StackExchangeIcon',
  height: 512,
  width: 448,
  svgPath: 'M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default StackExchangeIcon;